var _rect, _rect2, _rect3, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobileTextDeisgn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 236,
    height: 50,
    viewBox: "0 0 236 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.370837,
    y: 0.370837,
    width: 234.632,
    height: 49.201,
    rx: 10.2605,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.370837,
    y: 0.370837,
    width: 234.632,
    height: 49.201,
    rx: 10.2605,
    stroke: "#6D5E57",
    strokeWidth: 0.741724
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2.71948,
    y: 2.71973,
    width: 229.934,
    height: 44.5034,
    rx: 8.90069,
    fill: "#7E0822"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_46_437)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.6201,
    y: 6.6756,
    width: 212.133,
    height: 36.5917,
    rx: 3.95586,
    fill: "#F9EEDF",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.3994 12.6092H17.1936L14.0925 9.14783H28.2984L31.3994 12.6092Z",
    fill: "#790320"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.2681 12.6092H38.8167L35.948 9.14783H31.3994L34.2681 12.6092Z",
    fill: "#790320"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.6853 12.6092H46.2339L43.3652 9.14783H38.8167L41.6853 12.6092Z",
    fill: "#790320"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.1028 12.6092H53.6514L50.7827 9.14783H46.2341L49.1028 12.6092Z",
    fill: "#790320"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 217.326,
    cy: 12.6093,
    r: 4.45035,
    fill: "#7E0339"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.188 15.5761L215.75 13.1993L213.864 11.6007L216.356 11.3893L217.325 9.14783L218.295 11.3893L220.787 11.6007L218.9 13.1993L219.463 15.5761L217.325 14.3158L215.188 15.5761Z",
    fill: "#FFCE55"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.0372,
    y1: 35.3556,
    x2: 55.6289,
    y2: 35.3556,
    stroke: "#FD6F12",
    strokeWidth: 0.988966,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.0372,
    y1: 38.817,
    x2: 41.2889,
    y2: 38.817,
    stroke: "#FD6F12",
    strokeWidth: 0.988966,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5671 40.0842C20.5408 40.2024 20.479 40.3096 20.39 40.3917C20.301 40.4737 20.189 40.5265 20.0692 40.5431C19.9493 40.5597 19.8272 40.5392 19.7192 40.4844C19.6113 40.4296 19.5228 40.3431 19.4654 40.2365L18.4319 38.7071L16.0055 41.1335C15.9565 41.1825 15.8983 41.2214 15.8343 41.2479C15.7703 41.2744 15.7017 41.2881 15.6324 41.2881C15.5631 41.2881 15.4945 41.2744 15.4305 41.2479C15.3665 41.2214 15.3083 41.1825 15.2593 41.1335L14.7416 40.6158C14.6926 40.5668 14.6537 40.5086 14.6272 40.4446C14.6007 40.3806 14.5871 40.312 14.5871 40.2427C14.5871 40.1734 14.6007 40.1048 14.6272 40.0408C14.6537 39.9768 14.6926 39.9186 14.7416 39.8696L17.168 37.4432L15.6287 36.4097C15.5221 36.3523 15.4357 36.2637 15.3809 36.1558C15.3261 36.0478 15.3057 35.9257 15.3223 35.8058C15.3389 35.6859 15.3918 35.5739 15.4739 35.485C15.556 35.396 15.6633 35.3343 15.7815 35.308L22.4976 33.3776L20.5671 40.0842Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.741724,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_46_437",
    x: 10.6312,
    y: 6.6756,
    width: 213.122,
    height: 37.5807,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.988966,
    dy: 0.988966
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.996078 0 0 0 0 0.435294 0 0 0 0 0.0627451 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_46_437"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_46_437",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileTextDeisgn);
export default __webpack_public_path__ + "static/media/mobile_text_deisgn.c4ea1524be823c61742f23c961157a01.svg";
export { ForwardRef as ReactComponent };